import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { I18nProvider } from "./i18n";
import PrintProvider, { NoPrint } from "react-easy-print";

const app = (
  <I18nProvider>
    <PrintProvider>
      <NoPrint>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </NoPrint>
    </PrintProvider>
  </I18nProvider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
